import { render, staticRenderFns } from "./WatermarkLogoEditor.vue?vue&type=template&id=799f55a0&"
import script from "./WatermarkLogoEditor.vue?vue&type=script&lang=js&"
export * from "./WatermarkLogoEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports